import { tv } from 'tailwind-variants'

import { caption, h5 } from '@ui-kit/core/typography'

export const callToActionCard = tv({
  slots: {
    container:
      'flex cursor-pointer flex-row items-center gap-x-4 rounded-lg hover:opacity-70 active:opacity-70 web:transition web:duration-200 web:ease-in-out',
    image: 'h-16 w-16 rounded-lg',
    content: 'flex flex-1 flex-col',
    title: h5(),
    subtitle: caption({ emphasis: 'medium' }),
    tagContainer: 'flex flex-row pb-1',
    subtitleContainer: 'flex flex-row items-center',
    subtitleIconContainer: 'mr-1',
  },
  variants: {
    style: {
      light: {
        title: 'text-white',
        subtitle: 'text-white',
      },
      dark: {},
    },
  },
})
